export class Helper {
  public static open(url: string) {
    if (!url) return;
    
    if (!url.startsWith("https://")) {
      url = "https://" + url;
    }

    window.open(url, "_blank", "noopener");
  }

  public static navigateExternal(url: string) {
    // safe?
    window.location.replace(url);
  }

  public static navigateInternal(url: string) {
    if (!url) {
      url = "/";
    }

    if (!url.startsWith("/")) {
      url = "/" + url;
    }

    window.location.replace(url);
  }
}
